import { AfterViewInit, Component, EventEmitter, Input, Output, Pipe } from '@angular/core';
import { Modal } from '../modal';
import { ModalHeaderComponent } from '../components/modal-header/modal-header.component';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ILecturer } from '../../models/user/lecturer/lecturer.model';
import { ModalService } from '../../services/modal.service';
import { RoleType } from '../../enums/user/role-types.enum';
import { OrgMemberModalComponent } from '../org-member-modal/org-member-modal.component';
import { Operation } from '../../enums/utils/operations.enum';
import { SiLecturerItemComponent } from 'src/app/pages/admin/org-admin/events/admin-event/components/shop-item-modules/shop-item-module-lecturers/si-lecturers-modal/si-lecturer-item/si-lecturer-item.component';
import { IOrgUser, IUser } from '../../models/user/user.model';
import { ILocket } from '../../models/locket/locket.model';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { InputTextModule } from 'primeng/inputtext';
import { BehaviorSubject } from 'rxjs';
import { UserHelperService } from '../../services/helpers/user-helper.service';

@Pipe({
  name: 'searchFilter',
  standalone: true
})
class SearchFilterPipe {
  constructor(
    private userHelperService: UserHelperService
  ) {}

  transform(value: (ILecturer & { user: IUser & { orgUsers: IOrgUser[]; lockets: ILocket[];  } })[], search: string, orgId: number | null) {
    if (!search) return value;
    const searchLower = search.toLowerCase();
    return value.filter(x => {
      const userNameObj = this.userHelperService.getOrgUserObj(x.user.orgUsers, orgId);
      return (
        `${userNameObj.name} ${userNameObj.surname}`.toLowerCase().includes(searchLower) ||
        `${userNameObj.surname} ${userNameObj.name}`.toLowerCase().includes(searchLower) ||
        x.user.email?.toLowerCase().includes(searchLower)
      );
    });
  }
}

@Component({
  selector: 'app-lecturers-picker-modal',
  standalone: true,
  imports: [
    TranslateModule, ReactiveFormsModule,
    ButtonModule, ProgressSpinnerModule, InputTextModule,
    ModalHeaderComponent, SiLecturerItemComponent, SearchFilterPipe,
  ],
  templateUrl: './lecturers-picker-modal.component.html',
  styleUrl: './lecturers-picker-modal.component.scss'
})
export class LecturersPickerModalComponent extends Modal implements AfterViewInit {

  get lecturers() { return this.lecturers$.value; }
  @Input({required: true}) lecturers$ = new BehaviorSubject<(ILecturer & { user: IUser & { orgUsers: IOrgUser[]; lockets: ILocket[] } })[]>([]);
  @Input({required: true}) orgId: number | undefined;
  @Input({required: true}) selectedLecturerIds: number[] = [];

  searchFC = new FormControl<string>('', { nonNullable: true });
  selectedLecturersFC = new FormControl<number[]>([], { nonNullable: true });
  firstLecturerFC = new FormControl<string>('', { nonNullable: true });

  @Output() selectedLecturerIdsOut = new EventEmitter<number[]>();

  fetching: boolean = false;
  saving: boolean = false;

  constructor(
    private modalService: ModalService,
  ) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.selectedLecturersFC.setValue(this.selectedLecturerIds);
  }

  ngAfterViewInit(): void {
    this.focusInputs();
  }

  onSubmit() {
    this.selectedLecturerIdsOut.emit(this.selectedLecturersFC.value);

    this.close();
  }

  onAddFirstLecturer() {
    if (!this.orgId) return;

    const ref = this.modalService.openOrgMemberModal({
      c: OrgMemberModalComponent,
      operation: Operation.CREATE,
      toOrganizationId: this.orgId,
      preselectedRoles: [ RoleType.LECTURER ],
      initValues: {
        name: this.firstLecturerFC.value.split(' ')[0],
        surname: this.firstLecturerFC.value.split(' ')[1],
      }
    });
  }

  onAddLecturer() {
    if (!this.orgId) return;

    const ref = this.modalService.openOrgMemberModal({
      c: OrgMemberModalComponent,
      operation: Operation.CREATE,
      toOrganizationId: this.orgId,
      preselectedRoles: [ RoleType.LECTURER ],
    });
  }

  onSelectionChange(d: { e: Event, lecturerId: number }) {
    const selected = this.selectedLecturersFC.value;
    if (selected.includes(d.lecturerId)) {
      this.selectedLecturersFC.setValue(selected.filter(x => x !== d.lecturerId));
    } else {
      this.selectedLecturersFC.setValue([...selected, d.lecturerId]);
    }
  }

  private focusInputs() {
    setTimeout(() => {
      const els = document.querySelectorAll('.focus-input');
      els.forEach(x => (x as HTMLInputElement).focus());
    })
  }

  get showFirstLecturerInterface() {
    if (this.lecturers?.length === 0) return true;
    return false;
  }

  get availableLecturersSelected() {
    return this.lecturers?.filter(x => this.selectedLecturersFC.value.includes(x.id)) ?? [];
  }
  get availableLecturersUnselected() {
    return this.lecturers?.filter(x => !this.selectedLecturersFC.value.includes(x.id)) ?? [];
  }


  override ngOnDestroy(): void {
    super.ngOnDestroy();
    
  }

}
